/* Waco Diamonds - stop the variant section-render from scrolling the page on every option tap.

   After any option change (Metal Color / Karat / Carat / Quality) the native product-page.js
   re-fetches the product section and, once it lands, re-focuses the changed control:

       document.querySelector(`#${focusId}`).focus();   // assets/product-page.js

   Our option inputs are visually-hidden radios (position:absolute; width:1px; height:1px;
   clip:rect(0 0 0 0)) that sit well down the page, below the media gallery. A plain focus()
   scrolls the viewport to bring that hidden 1px box into view, so the page visibly JUMPS on
   every tap - most disruptive on mobile, where the reporter saw "it keeps changing the
   position of the page." (Verified: focusing such a radio from scrollY 0 jumped the page to
   ~891px; focus({preventScroll:true}) leaves scroll untouched.)

   Fix: make focus() default to preventScroll for controls INSIDE the ring variant-picker.
   The a11y focus move is preserved (the correct radio still becomes document.activeElement),
   only the scroll side effect is dropped. Scoped to <variant-picker> so nothing else changes.
   Lives in a waco-* asset (not the native file) so a theme update that re-pushes
   product-page.js cannot silently reintroduce the jump. */
(function () {
  "use strict";
  if (window.__wacoFocusNoScroll) return;
  window.__wacoFocusNoScroll = true;

  var proto = window.HTMLElement && window.HTMLElement.prototype;
  if (!proto || typeof proto.focus !== "function") return;

  var nativeFocus = proto.focus;
  proto.focus = function (options) {
    try {
      if (this && typeof this.closest === "function" && this.closest("variant-picker")) {
        if (options === undefined || options === null) {
          options = { preventScroll: true };
        } else if (typeof options === "object" && options.preventScroll === undefined) {
          options = Object.assign({}, options, { preventScroll: true });
        }
      }
    } catch (e) {
      /* never let the shim break native focus */
    }
    return nativeFocus.call(this, options);
  };
})();
